import React from 'react'
import { useQuery } from 'jsonapi-react'
import { useParams } from 'react-router-dom'
import NotFoundPage from './pages/NotFoundPage'
import ErrorPage from './pages/ErrorPage'
import CountryPage from 'app/countries/CountryPage'
import RegionPage from 'app/regions/RegionPage'
import CityPage from 'app/cities/CityPage'

export default function FoodTrucksRouter(props) {
  const params = useParams()
  const placeSlug = params.placeSlug || `${params.citySlug}-${params.regionCode}`

  const query = useQuery(['places', {
    filter: {
      slug: placeSlug,
    }
  }])

  if (query.isLoading) {
    return null
  }

  if (query.error || !query.data) {
    return <ErrorPage />
  }

  const place = query.data[0]

  if (!place || place.type === 'country') {
    return <NotFoundPage />
  }

  return place.type === 'country' ? (
    <CountryPage country={place} {...params} />
  ) : place.type === 'region' ? (
    <RegionPage region={place} {...params} />
  ) : (
    <CityPage city={place} {...params} />
  )
}
